import { Component, Inject, LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent {
  allBrands = [
    {
      "image": "kids.png",
    },
    {
      "image": "dp-school.png",
    },
    {
      "image": "dahampasala.png",
    },
    {
      "image": "pirivena.png",
    },
    {
      "image": "prachina.png",
    },
    {
      "image": "code.png",
    },
    {
      "image": "it-campus.png",
    },
    {
      "image": "olympiad-math.png",
    },
    {
      "image": "olympiad-info.png",
    },
    {
      "image": "ielts.png",
    },
    {
      "image": "japanese.png",
    },
    {
      "image": "italian.png",
    },
    {
      "image": "korean.png",
    },
    {
      "image": "tvet.png",
    },
    {
      "image": "uni.png",
    },
    {
      "image": "lib.png",
    },
    {
      "image": "skills.png",
    },
    {
      "image": "publichealth.png",
    }
  ]

  prog1 = [
    {
      "image": "kids.png",
    }
  ]

  prog2 = [
    {
      "image": "dp-school.png",
    },
   
    {
      "image": "it-campus.png",
    },
    {
      "image": "uni.png",
    },
    {
      "image": "lib.png",
    },
    {
      "image": "remote-robotics.png",
    },
    {
      "image": "code.png",
    },
    {
      "image": "sports.png",
    }
  ]

  prog3 = [
    {
      "image": "code.png",
    },
    {
      "image": "it-campus.png",
    },
    {
      "image": "remote-robotics.png",
    }
  ]

  prog4 = [
    {
      "image": "tvet.png",
    },
    {
      "image": "lib.png",
    }
  ]
  prog5 = [
   
    {
      "image": "ielts.png",
    },
    {
      "image": "japanese.png",
    },
    {
      "image": "italian.png",
    },
    {
      "image": "korean.png",
    },
    {
      "image": "chinese.png",
    }
  ]

  prog6 = [
    {
      "image": "dahampasala.png",
    },
    {
      "image": "pirivena.png",
    },
    {
      "image": "prachina.png",
    }
  ]

  prog7 = [
    {
      "image": "code.png",
    },
    {
      "image": "it-campus.png",
    },
    {
      "image": "remote-robotics.png",
    }
  ]

  prog8 = [
    {
      "image": "olympiad-math.png",
    },
    {
      "image": "olympiad-info.png",
    }
  ]

  prog9 = [
    {
      "image": "econ.png",
    },
    {
      "image": "dp-school.png",
    },
  ]

  prog10 = [
    {
      "image": "publichealth.png",
    }
  ]

  prog11 = [
    {
      "image": "lib.png",
    },
    {
      "image": "skills.png",
    },
    {
      "image": "publichealth.png",
    },
    {
      "image": "sports.png",
    }
  ]

  prog12 = [
    {
      "image": "sports.png",
    },
    {
      "image": "track-and-field.png",
    },
    {
      "image": "cricket.png",
    },
    {
      "image": "volley-ball.png",
    },
    {
      "image": "netball.png",
    }
  ]
  
  constructor(@Inject(LOCALE_ID) public locale: string) {


  }
}
